<template>
  <div class="picker-line">

    <div  class="checkbox-wrapper" :class="{'none': removeCheckboxDiv}">
      <v-checkbox hide-details
                  height="0"
                  v-if="dataShowCheckbox"
                  :input-value="dataActive"
                  @click="checkBoxClick"></v-checkbox>
    </div>

    <div v-if="!isGradient"
         class="picker-wrapper not-gradient"
         :class="{'center': backGroundColorEditor}"
         :style="style"
         @click="click">
      <sketch-picker v-if="selected"
                     :value="colors"
                     @input="emitInput"></sketch-picker>
    </div>
    <div v-if="isGradient"
         class="picker-wrapper"
         :class="{'picker-wrapper-interaction-background': removeCheckboxDiv}"
         :style="style"
         @click="click">
      <ColorPicker v-if="selected"
                  :isGradient="true"
                  :gradient="gradient"
                  :onEndChange="color => onChange(color, 'end')"/>

    </div>

    <div class="picker-line-name">{{dataControlName}}</div>

    <eyedropper v-if="eyedropper"
                :interaction="interaction"
                :type="type"
                :entity="entity"
                @input="(evt) => $emit('input', evt)" />

  </div>
</template>

<script>
import Eyedropper from "@views/interactions/components/SidePanel/components/Eyedropper.vue";
import rgbaToCss from "@mixins/rgba-to-css";
import selectable from "@mixins/selectable";
import { Sketch } from "vue-color";
import { ColorPicker } from 'vue-color-gradient-picker';
import vModel from "@mixins/v-model";
import EventBus from "@packages/event-bus";

export default {
  components: {
    SketchPicker: Sketch,
    ColorPicker,
    Eyedropper,
  },

  data() {
    return {
      timeout: null,
      gradient: {
        type: 'linear',
        degree: undefined,
        points: []
      }
    };
  },

  props: {
    dataShowCheckbox: {
      type: Boolean,
      required: false,
      default: true,
    },

    removeCheckboxDiv: {
      type: Boolean,
      required: false,
      default: false,
    },

    dataControlName: {
      type: String,
      required: true,
    },

    dataActive: {
      type: Boolean,
      required: false,
    },

    interaction: {
      type: Object,
    },

    type: {
      type: String,
      required: true,
    },

    eyedropper: {
      type: Boolean,
      default: true,
    },

    hex: {
      type: Boolean,
      default: false,
    },

    backGroundColorEditor: {
      type: Boolean,
      default: false
    },

    isGradient: {
      type: Boolean,
      default: false
    },

    entity: {
      type: String,
      required: false,
      default: 'interactions'
    }

  },

  computed: {
    style() {
      return this.isGradient ? {
        "background": this.val
      } :
      {
        "background-color": this.hex ? this.val : this.rgbaToCss(this.val),
      }
    },

    colors() {
      return this.hex
        ? this.val
        : {
            r: this.val.r,
            g: this.val.g,
            b: this.val.b,
            a: this.val.a,
          };
    },

  },

  watch: {
    isGradient(val) {
      if(val) {
        this.setGradientColors(this.val)
      }
    }
  },

  methods: {
    onChange(attrs) {
      this.$emit("input", `${attrs.style})`);
    },
    emitInput(event) {
      this.$emit("input", this.hex ? event.hex : event.rgba);
    },
    click(evt) {
      if (evt.target.className.includes("picker-wrapper") ) {
        if (this.selected) {
          EventBus.$emit("CLOSE_COLOR_PICKERS", evt);
          if(this.backGroundColorEditor) {
            EventBus.$emit("HANDLE_HEIGHT");
          }

        } else {
          EventBus.$emit("CLOSE_COLOR_PICKERS", evt);
          this.selected = true;
          if(this.backGroundColorEditor) {
            EventBus.$emit("HANDLE_HEIGHT");
          }
        }
      } else {
        EventBus.$emit("CLOSE_COLOR_PICKERS", evt);
        this.selected = true;
        if(this.backGroundColorEditor ) {
          EventBus.$emit("HANDLE_HEIGHT");
        }

      }

      evt.stopPropagation();
    },

    checkBoxClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      this.$emit("checkbox", !this.dataActive);
    },

    eventBusClick(evt) {
      if (evt.target !== this.$refs.button) this.selected = false;
    },

    closeColorPickerHandler() {
      this.selected = false;
    },

    setGradientColors(color) {
      if(typeof color === "string") {
        const arrayOfColors = []

        let degRegex = /(\d+)deg/;
        let degMatch = color.match(degRegex);

        if (degMatch) {
          let degree = degMatch[1];
          this.gradient.degree = Number(degree)
        }

        let colorRegex = /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([01](?:\.\d*)?)\)\s*([\d.]+)%/g;
        let colorMatches = [...color.matchAll(colorRegex)];

        if (colorMatches) {
          for (let i = 0; i < colorMatches.length; i++) {
              let match = colorMatches[i];
              let red = Number(match[1]);
              let green = Number(match[2]);
              let blue = Number(match[3]);
              let alpha = Number(match[4]);
              let percentage = match[5];

              arrayOfColors.push({
                left: percentage,
                red,
                green,
                blue,
                alpha
              })
          }
          this.gradient.points = [...arrayOfColors]

        }
      }
    }
  },

  mounted() {
    EventBus.$on("CLICK", this.eventBusClick);
    EventBus.$on("SIDE_PANEL_CLICK", this.eventBusClick);
    EventBus.$on("CLOSE_COLOR_PICKERS", this.closeColorPickerHandler);
    this.setGradientColors(this.val)
  },

  beforeDestroy() {
    EventBus.$off("CLICK", this.eventBusClick);
    EventBus.$off("SIDE_PANEL_CLICK", this.eventBusClick);
    EventBus.$off("CLOSE_COLOR_PICKERS", this.closeColorPickerHandler);
  },

  mixins: [selectable, rgbaToCss, vModel],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.picker-line {
  display: flex;
  align-items: center;
  font-size: 14px;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  .checkbox-wrapper {
    width: 32px;
  }

  .none {
    display: none;
  }

  .picker-wrapper {
    position: relative;
    width: 34px;
    height: 20px;

    border-radius: 8px;
    margin-right: 18px;
    border: 1px solid $grey-4;

    & > * {
      position: absolute;
      top: 20px;
      right: -180px;
      z-index: 5;
    }
  }

  .picker-wrapper-interaction-background {

    .ui-color-picker {
      ::v-deep .gradient-controls {
        justify-content: end;
      }
      ::v-deep .gradient-type {
        display: none;
      }

      ::v-deep p{
       margin-bottom: 0;

      }

      ::v-deep input {
        font-weight: 400;
      }

      ::v-deep .input-field .label  {
        font-weight: 400;
      }
    }

    & > * {
      position: absolute;
      top: 30px;
      right: -245px;
      z-index: 5;
    }
  }

  .center {
    & > * {
      position: absolute;
      top: 30px;
      right: -210px;
      z-index: 5;
    }
  }

  .picker-line-name {
    color: #4d4f5c;
  }
}
</style>
<style src="vue-color-gradient-picker/dist/index.css" lang="css" />
